<template>
  <Teleport to="#vue-modal" :disabled="hidden">
    <div :class="mainModalClass">
      <div class="modalShade" @click="hideModal"></div>
      <!--    {/* Modal content */}-->
      <div class="bg-white rounded-lg shadow-sm modalContent max-w-fit max-h-[80vh] p-6 pr-0 flex-col items-start gap-6 inline-flex" :class="mainModalClass">
        <div class=" items-start inline-flex pr-6">
          <div class="tw-modal-header">{{ title }}</div>
        </div>

        <div v-if="hasSlottedContent" class="overflow-y-auto pr-6 flex-col items-start gap-2 flex w-full" :class="contentClass"  >
          <slot/>
        </div>
        <div v-if="buttons" class="self-stretch pr-6 justify-end items-start gap-4 inline-flex">
          <div v-for="button in buttons" data-modal-toggle="default-modal" type="button" @click="$emit(button.action)"
               :class="button.styles || 'text-vc-gray-500 bg-white float-right hover:bg-gray-100 focus:ring-4 focus:ring-gray-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10'">
            {{ button.title }}
          </div>
        </div>
      </div>

    </div>
  </Teleport>
</template>
<script>


export default {
  props: ['title', 'buttons', 'mainModalClass', 'contentClass', 'hidden'],
  emits: {
    close: {},
  },
  computed: {
    hasSlottedContent() {
      return !!this.$slots.default;
    },
  },
  methods: {
    hideModal(){
      this.$emit('close')
    },
  },
}
</script>
